<template>
  <easy-home v-if="useEasyHome"></easy-home>
  <v-container v-else>
    <v-row justify="center">
      <v-col md="8" cols="12" :style="{minWidth: '550px', maxWidth: '700px'}">
        <v-card>
          <v-card-title>ショートカット</v-card-title>
          <v-card-text>
            <navigation-list grid></navigation-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4" cols="12">
        <v-card tile dark color="grey darken-3" class="my-account">
          <v-card-title>マイ アカウント</v-card-title>
          <v-card-text>
            <v-simple-table dense :style="{backgroundColor: 'transparent'}">
              <tbody>
                <tr>
                  <th>ID: </th>
                  <td>{{ myAccount.user.id }}</td>
                </tr>
                <tr>
                  <th>アカウント名: </th>
                  <td>{{ myAccount.user.name }}</td>
                </tr>
                <tr>
                  <th>Email: </th>
                  <td>{{ myAccount.user.email }}</td>
                </tr>
                <tr>
                  <th>所属事業者名: </th>
                  <td>{{ myAccount.user.owner && myAccount.user.owner.name }}</td>
                </tr>
                <tr>
                  <th>所属サイト名: </th>
                  <td>{{ myAccount.user.terminal.name }}</td>
                </tr>
                <tr v-if="myAccount.user.permissionAdmin">
                  <th>事業者管理権限: </th>
                  <td><readonly-checkbox :value="true" color="white"/></td>
                </tr>
                <tr v-if="myAccount.user.permissionContract">
                  <th>取引管理権限: </th>
                  <td><readonly-checkbox :value="true" color="white"/></td>
                </tr>
                <tr v-if="myAccount.user.permissionImplementation">
                  <th>実装管理権限: </th>
                  <td><readonly-checkbox :value="true" color="white"/></td>
                </tr>
                <tr v-if="myAccount.user.permissionDictionary">
                  <th>辞書管理権限: </th>
                  <td><readonly-checkbox :value="true" color="white"/></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import NavigationList from "@/components/organisms/NavigationList.vue";
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";
import PageStoreMixin, {mapPageStores} from "@/utils/PageStoreMixin";
import EasyHome from "@/components/pages/easy/EasyHome.vue";

export default {
  name: 'Home',
  components: {EasyHome, ReadonlyCheckbox, NavigationList},
  mixins: [PageStoreMixin],
  computed: {
    ...mapGetters({
      account: 'account'
    }),
    ...mapPageStores({
      useEasyHome: {alt: true, key: 'app.useEasyHome'},
    }),
    myAccount() {
      const result = {user: {terminal: {}}, owner: {}};
      if(this.account.user) {
        result.user = this.account.user;
      }
      if(this.account.owner) {
        result.owner = this.account.owner;
      }
      return result;
    }
  }
}
</script>

<style lang="scss" scoped>
.my-account {
  th {
    text-align: start;
    white-space: nowrap;
  }
  td {
    white-space: pre-wrap;
    word-break: break-all;
  }
}
</style>
